
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import ScreenIsWideEnough from '@/mixins/screenIsWideEnough';
import { Category } from '@/types/categories';
import MainMenuTile from './MainMenuTile.vue';
import { MainMenuItem } from '@/types/mainMenuItems';
import _ from 'lodash';

const makeMenuItem = (category: Category): MainMenuItem => {
  let categoryMenu: MainMenuItem = {
    slug: 'content/' + category.meta!.slug,
    icon: category.icon,
    open_icon: category.icon,
    title: category.meta!.title,
  };

  if (category.children) {
    categoryMenu.children = category.children.map(makeMenuItem);
  }

  return categoryMenu;
};

@Component({
  components: { MainMenuTile },
})
export default class MainMenu extends Mixins(ScreenIsWideEnough) {
  @Getter('categories/categories') categories!: Category[];
  @Action('categories/getCategories') getCategories!: Function;

  tree = [];

  active = [''];

  openItem = [''];

  staticMenuItems: MainMenuItem[] = [
    { slug: 'menus', title: 'Menus', icon: 'fab fa-elementor' },
    { slug: 'blocks', title: 'Blocks', icon: 'fas fa-cubes' },
    { slug: 'categories', title: 'Categories', icon: 'fa-cat' },
    { slug: 'images', title: 'Images', icon: 'fa-images' },
    { slug: 'pages', title: 'Pages', icon: 'fa-file-invoice' },
    { slug: 'funders', title: 'Funders', icon: 'fa-coins' },
    { slug: 'redirects', title: 'Redirects', icon: 'fas fa-directions' },
    { slug: 'builds', title: 'Builds', icon: 'fa-wrench' },
  ];

  menuItems(): MainMenuItem[] {
    let contentMenu = _.find(
      this.staticMenuItems,
      item => item.slug === 'content',
    );
    if (this.categories.length > 0 && _.isUndefined(contentMenu)) {
      this.staticMenuItems.push({
        slug: 'content',
        title: 'Content',
        icon: 'fa-folder',
        open_icon: 'fa-folder-open',
        children: this.categoryMenuItems,
      });
    }
    return this.staticMenuItems;
  }

  get categoryMenuItems(): MainMenuItem[] {
    return this.orderedCategories().map(makeMenuItem);
  }

  orderedCategories() {
    return _.orderBy(this.categories, ['name'], ['asc']);
  }

  menuLink(slug: string) {
    if (slug !== '') {
      this.$router.push(`/${slug}`);
    }
    this.active = [slug];
  }

  @Watch('categories', { immediate: true, deep: true })
  onCategoriesChanged() {
    let contentMenuIndex = this.staticMenuItems.findIndex(
      (menuItem: MainMenuItem) => menuItem.slug === 'content',
    );
    if (contentMenuIndex >= 0) {
      this.staticMenuItems.splice(contentMenuIndex, 1);
    }
    this.menuItems();
  }

  created() {
    this.getCategories();
  }
}
